module.exports = __webpack_public_path__ + "static/video-082e833815f50e24a060c18666207dcd.mp4";